<template>
<div>
  <w-sliding-popup ref="logSlidingPopup" title="최근 12시간 로그 목록">
    <div slot="content">
      <el-row type="flex" class="title-bar" :style="'justify-content:' + (!rowdataSaveFlag ? 'flex-end;' : 'space-between;')">
        <el-radio-group class="ordinary" v-model="logType" v-if="rowdataSaveFlag" @change="loadLogData">
          <el-radio-button label="SYSLOG" v-if="isSyslog">시스템 로그</el-radio-button>
          <el-radio-button label="SNMPTRAP" v-if="isSnmpTrap">SNMP 트랩</el-radio-button>
        </el-radio-group>
        <div class="title-bar">
          <div v-if="!isVirtual">
            <el-radio-group class="mr-r10" v-model="searchLogType" @change="loadLogData">
              <el-radio label="origin">원본 로그</el-radio>
              <el-radio label="filtering">필터링 로그</el-radio>
            </el-radio-group>
            <el-select v-model="searchTypeCheck" v-show="searchLogType === 'filtering'" :disabled="searchLogType === 'origin'" @change="loadLogData">
              <el-option label="전체" value="total"></el-option>
              <el-option label="확인" value="checked"></el-option>
              <el-option label="미확인" value="unchecked"></el-option>
            </el-select>
          </div>
          <div v-if="isVirtual">
            <el-radio-group v-model="selectType" style="margin-left: 10px;">
              <el-radio :label="'task'">작업 정보</el-radio>
              <el-radio :label="'event'">이벤트 정보</el-radio>
              <el-radio :label="'alarm'">경보</el-radio>
            </el-radio-group>
          </div>
          <w-header-search-button size="mini" class="mr-l4" @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-row>
        <el-table-wrapper :data="tableData" :columns="columns" :total="total" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool" ref="logTable" :show-overflow-tooltip="true"
          :pagination="true" remote @condition-change="loadLogData">
          <template slot-scope="scope" slot="relation-event">
              <span v-if="scope.row.histChainKey" @click="relationEventClick(scope.row)"><i class="far fa-search-plus c-pointer"></i></span>
          </template>
        </el-table-wrapper>
      </el-row>
    </div>
  </w-sliding-popup>
  <w-vcenter-log-event-popup ref="vcenterLogEventPopup" />
</div>
</template>


<script>
import MsgUtil from '@/utils/message';
import { isTrue } from '@/utils/boolean';
import APPLogAPI from '@/api/log/common';
import VirtualLogAPI from '@/api/virtual/performance/log';
import { mapGetters } from 'vuex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import { isNil, findIndex, forEach, isEqual, split } from 'lodash';
import { getIntervalDatetimeParams, getDateToString } from '@/utils/date';
import WVcenterLogEventPopup from '@/views/performance/components/virtual/VcenterLogEventPopup';

export default {
  name: 'WSearchLogPopup',
  components: {
    WPerfAnalysisTimeInfo,
    WVcenterLogEventPopup,
  },
  props: {},
  data() {
    return {
      /**
       * 조회 장비 객체
       * @type {[type]}
       */
      obj: null,
      logType: 'APP',
      /**
       * 가상화장비 여부
       * @type {Boolean}
       */
      isVirtual: false,
      columnDefault,
      showSearchTool: false,
      searchLogType: 'origin',
      searchTypeCheck: 'total',
      selectType: 'task',
      rowdataSaveFlag: null,
      total: 0,
      tableData: [],
      columns: [],
      isSyslog: false,
      isSnmpTrap: false,
    };
  },
  computed: {
    ...mapGetters(['activeManagetypeIds']),
    isLms() {
      return findIndex(this.activeManagetypeIds, (item) => item === 'LMS') >= 0;
    },
  },
  methods: {
    open() {
      this.$refs.logSlidingPopup.open();
    },
    /**
     * 팝업 오픈 시 데이터를 초기화
     * @author Hunui
     * @param  {[type]} obj [description]
     * @return {[type]}     [description]
     */
    initData(obj) {
      this.obj = obj;
      const typeArray = split(obj.logType, '.');
      this.rowdataSaveFlag = false;
      this.isSyslog = false;
      this.isSnmpTrap = false;
      if (typeArray.length === 1) {
        this.isVirtual = false;

        // 검색 결과를 가공하기 위한 과정 중 SYSLOG와 SNMPTRAP을 GROUP BY 하기 때문에
        // Flag로 분기 처리를 하였습니다. 둘 다 활성화 된 결과라면 SYSLOG 를 logType에 담습니다.
        if (isTrue(obj.rawdataSaveFlagSnmptrap) || isTrue(obj.rawdataSaveFlagSyslog)) {
          this.rowdataSaveFlag = true;
          if (isTrue(obj.rawdataSaveFlagSnmptrap) && isTrue(obj.rawdataSaveFlagSyslog)) {
            this.logType = 'SYSLOG';
            this.isSyslog = true;
            this.isSnmpTrap = true;
          } else if (isTrue(obj.rawdataSaveFlagSyslog)) {
            this.logType = 'SYSLOG';
            this.isSyslog = true;
          } else {
            this.logType = 'SNMPTRAP';
            this.isSnmpTrap = true;
          }
        } else {
          this.logType = typeArray[0];
        }
      } else {
        this.isVirtual = true;
        this.logType = typeArray[1];
      }
      this.searchLogType = 'origin';
      this.searchTypeCheck = 'total';
      this.selectType = 'task';
      this.setColumns();
      this.loadLogData();
    },
    loadLogData() {
      const params = this.setParams();

      const action = MsgUtil.action.VIEW;
      const target = '로그 정보';

      if (this.isVirtual) {
        VirtualLogAPI.getVcenterLogByHistType(params)
          .then((response) => {
            if (response.data.success) {
              this.tableData = response.data.data;
              this.total = response.data.total;
            } else {
              this.$message(MsgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch((e) => {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
            throw new Error(e);
          });
      } else {
        APPLogAPI.getLogAnalysisData(params)
          .then((response) => {
            if (response.data.success) {
              this.tableData = response.data.data;
              this.total = response.data.total;
            } else {
              this.$message(MsgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch((e) => {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
            throw new Error(e);
          });
      }
    },
    setParams() {
      const tableSearchParams = this.$refs.logTable.getParameter();

      // 헤더 검색어 추가
      let queryList = [];

      if (this.logType === 'APP') {
        // 어플리케이션 로그
        if (!isNil(tableSearchParams.searchParams)) {
          forEach(tableSearchParams.searchParams, (item) => {
            queryList.push({ field: item.field, value: item.value, operator: 'AND' });
          });
        }
        // 1. 원본/필터링 로그 조회 타입 추가 (라디오)
        if (this.searchLogType === 'filtering') {
          // 필터링 로그
          queryList.push({ field: 'filterId', operator: 'EXIST' });
          // 2. 확인/미확인 조회 타입 추가 (콤보박스)
          if (this.searchTypeCheck === 'checked') {
            // 확인만
            queryList.push({ field: 'isChecked', value: '1', operator: 'AND' });
          } else if (this.searchTypeCheck === 'unchecked') {
            // 미확인만
            queryList.push({ field: 'isChecked', value: '0', operator: 'AND' });
          }
        }
      } else if (this.logType === 'SYSLOG' || this.logType === 'SNMPTRAP') {
        // 시스템 로그
        if (!isNil(tableSearchParams.searchParams)) {
          forEach(tableSearchParams.searchParams, (item) => {
            if (item.field === 'isChecked') {
              queryList.push({ field: item.field, value: item.value === '확인' ? '1' : '0', operator: 'AND' });
            } else {
              queryList.push({ field: item.field, value: item.value, operator: 'AND' });
            }
          });
        }
        if (this.searchLogType === 'filtering') {
          // 필터링 로그
          queryList.push({ field: 'filterId', operator: 'EXIST' });
          // 2. 확인/미확인 조회 타입 추가 (콤보박스)
          if (this.searchTypeCheck === 'checked') {
            // 확인만
            queryList.push({ field: 'isChecked', value: '1', operator: 'AND' });
          } else if (this.searchTypeCheck === 'unchecked') {
            // 미확인만
            queryList.push({ field: 'isChecked', value: '0', operator: 'AND' });
          }
        }
        if (this.isLms) {
          queryList.push({ field: 'objId', value: this.obj.objId, operator: 'AND', regex: 'N' });
          queryList.push({ field: 'logType', value: 'SYSLOG', operator: 'AND', regex: 'N' });
        }
      } else if (this.logType === 'TASK' || 'EVENT' || 'ALARM') {
        queryList = tableSearchParams.searchParams;
      }

      const params = {
        objId: this.obj.objId,
        logType: this.logType,
        type: 'performance',
        startDateTime: getIntervalDatetimeParams(new Date().getTime(), 'hour', 12),
        endDateTime: new Date().getTime(),
        start: tableSearchParams.start,
        limit: tableSearchParams.limit,
        queryList,
      };

      if (this.isVirtual) {
        params.virtualcenterGroupId = this.obj.subKey;
        params.objtypeId = this.obj.objtypeId;
      }
      return params;
    },
    relationEventClick(currentRow) {
      const params = {
        histChainKey: currentRow.histChainKey,
        startDateTime: getIntervalDatetimeParams(new Date().getTime(), 'hour', 12),
        endDateTime: new Date().getTime(),
        logType: this.logType,
        objtypeId: 'EVENT',
        objId: this.obj.objId,
      };
      this.$refs.vcenterLogEventPopup.open(params);
    },
    /**
     * 공백 문자열 체크 formatter
     */
    getStringFormatter(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    getStatusFormatter(row, column, value) {
      let returnValue = getValueAfterCheckEmpty(value);
      if (!isNil(value)) {
        if (isEqual(value, '1')) {
          returnValue = '확인';
        } else {
          returnValue = '미확인';
        }
      }
      return returnValue;
    },
    /**
     * [공통] 날짜 포맷터
     * @author jeee12
     * @param  {[type]} value    [description]
     * @param  {[type]} dataType 데이터 종류 (syslog테이블에서 LMS가 활성화된 경우, 다른 포매터 수행)
     * @return {[type]}          [description]
     */
    getDateFormatter(value, dataType) {
      if (this.isLms && dataType === 'SYSLOG') {
        if (!isNil(value)) {
          return getDateToString(getIntervalDatetimeParams(value, 'hour', 12), 'YYYY-MM-DD HH:mm:ss');
        }
      }
      return isNil(value) ? EMPTY_TEXT : getDateToString(value);
    },
    /**
     * 로그 타입에 맞는 컬럼 반환
     * @author Hunui
     * @return {[type]} [description]
     */
    setColumns() {
      let logColumns = [];
      if (this.logType === 'APP') {
        if (!this.isLms) {
          logColumns = [
            {
              prop: 'isChecked',
              label: '상태',
              width: 60,
              formatter: this.getStatusFormatter,
            },
            {
              prop: 'filterName',
              label: '필터',
              width: 150,
              showOverflowTooltip: true,
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              prop: 'message',
              label: '메시지',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              prop: '@timestamp',
              label: '수집시각',
              showOverflowTooltip: true,
              formatter: (row, column, value) => this.getDateFormatter(value),
              width: 200,
            },
          ];
        } else {
          logColumns = [
            {
              prop: 'isChecked',
              label: '상태',
              width: 60,
              formatter: this.getStatusFormatter,
            },
            {
              prop: 'sourceName',
              label: '로그 소스',
              width: 150,
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              prop: 'originMessage',
              label: '원본 메시지',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              prop: 'filterName',
              label: '정책 이름',
              width: 150,
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              prop: 'timestamp',
              label: '수집 시간',
              width: 160,
              searchable: true,
              searchType: 'date',
              formatter: (row, column, value) => this.getDateFormatter(value),
            },
          ];
        }
      } else if (this.logType === 'SYSLOG' || this.logType === 'SNMPTRAP') {
        if (!this.isLms) {
          logColumns = [
            {
              prop: 'severity',
              label: 'severity',
              showOverflowTooltip: true,
              width: 100,
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              prop: 'filterName',
              label: '필터',
              width: 150,
              showOverflowTooltip: true,
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              prop: 'message',
              label: '메시지',
              showOverflowTooltip: true,
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              prop: '@timestamp',
              label: '수집시각',
              showOverflowTooltip: true,
              formatter: (row, column, value) => this.getDateFormatter(value, 'SYSLOG'),
              width: 200,
            },
          ];
        } else {
          logColumns = [
            {
              prop: 'isChecked',
              label: '상태',
              width: 60,
              formatter: this.getStatusFormatter,
            },
            {
              prop: 'sourceName',
              label: '로그 소스',
              width: 150,
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              prop: 'originMessage',
              label: '원본 메시지',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              prop: 'filterName',
              label: '정책 이름',
              width: 150,
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              prop: 'timestamp',
              label: '수집 시간',
              width: 160,
              searchable: true,
              searchType: 'date',
              formatter: (row, column, value) => this.getDateFormatter(value, 'SYSLOG'),
            },
          ];
        }
      } else if (this.isVirtual) {
        if (this.logType === 'TASK') {
          logColumns = [
            {
              label: '상태',
              prop: 'isChecked',
              width: '100px',
              formatter: this.getStatusFormatter,
            },
            {
              label: '등급',
              prop: 'eventlevelName',
              width: '100px',
              scopedSlot: 'eventlevel-slot',
              columnKey: 'eventlevelId',
              searchable: true,
              searchType: 'eventlevel',
              remoteProp: 'eventlevelId',
            },
            {
              label: '필터명',
              prop: 'filterName',
              width: '100px',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              label: '이름',
              prop: 'message',
              remoteProp: 'message',
              width: '400px',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              label: '대상',
              prop: 'objName',
              remoteProp: 'objName',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              label: '시작자 / 와치올 사용자',
              prop: 'mgrName',
              remoteProp: 'mgrName',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              label: '사용자 IP',
              prop: 'mgrIp',
              remoteProp: 'mgrIp',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              label: '시작시간',
              prop: 'timestamp',
              width: '150px',
              remoteProp: 'timestamp',
              formatter: (row, column, value) => this.getDateFormatter(value),
            },
          ];
        } else if (this.logType === 'EVENT') {
          logColumns = [
            {
              label: '상태',
              prop: 'isChecked',
              width: '100px',
              formatter: this.getStatusFormatter,
            },
            {
              label: '등급',
              prop: 'eventlevelName',
              width: '100px',
              scopedSlot: 'eventlevel-slot',
              columnKey: 'eventlevelId',
              searchable: true,
              searchType: 'eventlevel',
              remoteProp: 'eventlevelId',
            },
            {
              label: '필터명',
              prop: 'filterName',
              width: '100px',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              label: '설명',
              prop: 'message',
              remoteProp: 'message',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              label: '대상',
              prop: 'objName',
              width: '300px',
              remoteProp: 'objName',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              label: '날짜 시간',
              prop: 'timestamp',
              width: '150px',
              remoteProp: 'timestamp',
              formatter: (row, column, value) => this.getDateFormatter(value),
            },
          ];
        } else if (this.logType === 'ALARM') {
          logColumns = [
            {
              label: '상태',
              prop: 'isChecked',
              width: '100px',
              formatter: this.getStatusFormatter,
            },
            {
              label: '등급',
              prop: 'eventlevelName',
              width: '100px',
              scopedSlot: 'eventlevel-slot',
              columnKey: 'eventlevelId',
              searchable: true,
              searchType: 'eventlevel',
              remoteProp: 'eventlevelId',
            },
            {
              label: '필터명',
              prop: 'filterName',
              width: '100px',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              label: '대상',
              prop: 'objName',
              width: '300px',
              remoteProp: 'objName',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              label: '이름',
              prop: 'message',
              remoteProp: 'message',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              label: '상태',
              prop: 'status',
              width: '100px',
              remoteProp: 'status',
              searchable: true,
              formatter: this.getStringFormatter,
            },
            {
              label: '트리거된 시간',
              prop: 'timestamp',
              width: '150px',
              remoteProp: 'timestamp',
              formatter: (row, column, value) => this.getDateFormatter(value),
            },
          ];
        }
      }
      this.columns = [];
      this.$nextTick(() => {
        this.columns = logColumns;
      });
    },
  },
};
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/SmartSearchPopup/SearchResultView/popup/SearchLogPopup.vue